<div class="row mb-4">
    <div class="col-12">
        <div class="d-flex justify-content-end">
            <div *ngIf="hasToggle" class="d-flex align-items-center cursor-pointer" data-uit="toggle-application" (click)="toggled = !toggled">
                <span>{{ 'APPLICATIONS.DESCRIPTION' | translate }}</span>
                <ca-icon class="ms-2" [name]="toggled ? 'arrow-up' : 'arrow-down'" size="s"></ca-icon>
            </div>
        </div>
    </div>
</div>
<div *ngIf="toggled" @ngIfAnimation class="row mb-6">
    <div *ngIf="type === ApplicationType.Public && application.images.length > 0" @easeInOut class="gallery-image-section">
        <ngb-carousel data-interval="false">
            <ng-template ngbSlide *ngFor="let image of application.images">
                <div class="image-container">
                    <img [src]="image" />
                </div>
            </ng-template>
        </ngb-carousel>
    </div>
    <div class="col" data-uit="application-detail">
        <div @easeInOut class="row no-gutters">
            <div class="col">
                <ca-information-item [label]="'GENERAL.DESCRIPTION' | translate">
                    <div class="description">{{ application?.description }}</div>
                </ca-information-item>
            </div>

            <div class="col ps-2" *ngIf="type === ApplicationType.Public">
                <ca-information-item [label]="'APPLICATIONS.REQUIREMENTS' | translate">
                    <div>{{ application?.requirements }}</div>
                </ca-information-item>
            </div>
        </div>

        <div @easeInOut class="row no-gutters mt-3">
            <div class="col pe-2">
                <ca-information-item [label]="'APPLICATIONS.SUMMARY' | translate">
                    <p>{{ application?.summary }}</p>
                </ca-information-item>
            </div>
            <div class="col">
                <div class="row no-gutters">
                    <div class="col-6 pe-2">
                        <ca-information-item [label]="'APPLICATIONS.CREATED_BY' | translate">
                            <p>{{ application?.createdBy }}</p>
                        </ca-information-item>
                    </div>

                    <div class="col-6">
                        <ca-information-item [label]="'APPLICATIONS.VERSION' | translate">
                            <p *ngIf="application?.mlModels.length > 0">{{ application?.mlModels[0].version }}</p>
                        </ca-information-item>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
